// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5xukw","backButton":"Header_backButton__rH8Bk","userCount":"Header_userCount__+JSH9"};